/**
 * Polyfills for modern JavaScript features not available in ES2020
 * Must be imported FIRST in main.tsx before any other code
 */

/**
 * Array.at() polyfill for older browsers
 * Required for web-vitals library which uses this ES2022 method
 * Browser support: Safari < 15.4, Chrome < 92, Firefox < 90
 */
if (!Array.prototype.at) {
   
  Array.prototype.at = function (index: number) {
    // Convert negative index to positive
    const k = index >= 0 ? index : this.length + index;
    // Return undefined if out of bounds
    if (k < 0 || k >= this.length) {
      return undefined;
    }
    return this[k];
  };
}
